import createCrudVuexModule from "@/store/crud";

export const organizationControlHistory = createCrudVuexModule({
  namespaced: true,
  path: "/audit-control/control/history",
  moduleName: "organizationControlHistory",
  options: {
    localizedFields: [],
  },
  state: {},
  getters: {},
  mutations: {},
  actions: {},
});
